import * as React from 'react';
import type { FieldProps, TextareaProps } from '@fluentui/react-components';
import { Field, Textarea as FluentTextarea } from '@fluentui/react-components';

export function TextareaField({
  label,
  className,
  hint,
  validationMessage,
  validationState,
  required,
  ...props
}: TextareaProps & Pick<FieldProps, 'required' | 'label' | 'validationMessage' | 'validationState' | 'hint'>) {
  return (
    <Field
      hint={hint}
      label={label}
      className={className}
      validationMessage={validationMessage}
      validationState={validationState}
      required={required}
    >
      <FluentTextarea {...props} />
    </Field>
  );
}
